import { SelectionModel } from "@angular/cdk/collections";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { MatMenuTrigger } from "@angular/material/menu";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatDialog } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { environment } from "src/environments/environment";
import { NgxSpinnerService } from "ngx-spinner";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { TraslateService } from "src/app/traslate.service";
import { PushNotificationsService } from "ng-push-ivy";

@Component({
  selector: "app-report-history",
  templateUrl: "./report-history.component.html",
  styleUrls: ["./report-history.component.scss"],
})
export class ReportHistoryComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  tableDataSource: any = [];
  rangeForm = new FormGroup({
    start: new FormControl(new Date(localStorage.getItem("startDateValue"))),
    end: new FormControl(new Date(localStorage.getItem("endDateValue"))),
  });
  DateStart: string;
  DateEnd: string;
  minDate: Date = new Date(2010, 1, 1);
  maxDate: Date = new Date();
  collection: any = [];
  lengthpage: number = 100;
  pageSizeOptions1: number[];
  pageNum: any;
  manualPage: number = 0;
  manualPage1: number;
  public currentPage = 0;
  public totalSize = 0;
  pageSizeOptions = [15, 30, 100];
  pageSize1: any;
  pageSize = 15;
  index2: any = 10;
  selection = new SelectionModel<any>(true, []);
  selectedRow;
  selected: boolean;
  ItemSelected: any[];

  highlighted = false;
  selectedRowIndex: number = -1;

  displayedColumns = [
    "type",
    "export_type",
    "created_at",
    "start_period",
    "end_period",
    "downloads",
    "telechargement",
  ];
  dataSource = new MatTableDataSource();

  @ViewChild(MatMenuTrigger)
  contextMenu: MatMenuTrigger;

  contextMenuPosition = { x: "0px", y: "0px" };
  CodePostal: any;
  Nom: any;
  Groupe: any;

  myModel = true;

  veh: boolean = true;
  scr: boolean = true;
  URL: string;
  score_sfty_v1: HTMLElement;
  score_eco_v1: HTMLElement;
  score_eco_v2: HTMLElement;
  critere: any;
  op_sf1: any;
  op_sf2: any;
  op_ec1: any;
  op_ec2: any;
  rap_fl_v: boolean;
  mode: string;
  rap_d_v: boolean;
  rap_fl_c: boolean;
  rap_d_c: boolean;
  test: any;
  typerep: any;
  myObjStr: string;
  companie_id: any;
  id: any;

  @Input()
  urlSafe: SafeResourceUrl;
  lengthTotal: any;

  constructor(
    private _pushNotifications: PushNotificationsService,
    private _formBuilder: FormBuilder,
    public sanitizer: DomSanitizer,
    public traslateService: TraslateService,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private http: HttpClient,
    private spinnerreportUser: NgxSpinnerService
  ) {
    this._pushNotifications.requestPermission();

    this.getreportHistory(15,1)
  }

  ngOnInit() {
    // this.updateManualPage2(this.index2);
  }

  onContextMenu(event: MouseEvent, item: any) {
    event.preventDefault();
    this.contextMenuPosition.x = event.clientX + "px";
    this.contextMenuPosition.y = event.clientY + "px";
    this.contextMenu.menuData = { item: item };
    this.contextMenu.menu.focusFirstItem("mouse");
    this.contextMenu.openMenu();
  }

  onContextMenuAction1(item: any) {
    alert(`Click on Supprimer for ${item.name}`);
  }
  executeFunction() {
    //console.log(this.rangeForm)

    this.addNewDate(this.rangeForm);
  }

  addNewDate(e) {
    this.DateStart = new Date(e.value.start)
      ?.toString()
      .split("(")[0]
      .split("GMT")[0];
    //this.minDate = new Date(e.value.start)

    //var DateEnd2 = new Date(e.value.end)?.toISOString();
    this.DateEnd = new Date(e.value.end)
      ?.toString()
      .split("(")[0]
      .split("GMT")[0];
    //console.log(this.DateStart, this.DateEnd)
  }

  onContextMenuAction2(item: any) {
    alert(`Click on Modifier for ${item.name}`);
  }

  onContextMenuAction3(item: any) {
    alert(`Click on Activer/Désactiver for ${item.name}`);
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected?.length;
    const numRows = this.dataSource.data?.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => {
          this.selection.select(row);
        });
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? "select" : "deselect"} all`;
    }
    this.ItemSelected = this.selection.selected;

    //console.log(this.ItemSelected)

    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${
      row.id + 1
    }`;
  }

  GetSelectedRow(row) {
    if (this.selectedRowIndex === row.id) {
      this.selectedRowIndex = -1;
      this.selected = false;
    } else {
      this.selectedRow = row;
      this.selectedRowIndex = row.id;
      this.selected = true;

      //console.log("hello " + this.selectedRowIndex);
    }
  }

  //filtre global

  applyFilter(event: Event) {
    this.dataSource = new MatTableDataSource(this.tableDataSource);

    const filterValue = (event.target as HTMLInputElement).value;
    //console.log( this.dataSource)
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  public updateManualPage2(index2) {
    this.collection = [];

    //console.log(this.pageSizeOptions1)
    this.paginator.pageSize = index2;

    this.paginator.page.next({
      pageIndex: this.paginator.pageIndex,
      pageSize: index2,
      length: this.paginator.length,
    });

    this.lengthpage = parseInt("" + this.paginator?.length / index2);
    //console.log(this.lengthpage)

    for (var i = 0; i < this.lengthpage; i++) {
      this.collection.push(i + 1);
    }

    //console.log(this.collection)
  }

  public updateManualPage(index): void {
    //console.log(index)
    this.pageNum = index;
    this.manualPage = index;
    this.paginator.pageIndex = index;

    this.paginator.page.next({
      pageIndex: this.paginator.pageIndex,
      pageSize: this.paginator.pageSize,
      length: this.paginator.length,
    });
  }

  pageChanged(event){

    console.log(" pageChanged(event)  pageChanged(event) ")
    console.log(event);
    let pageIndex = event.pageIndex;
  let pageSize = event.pageSize;
  
  let previousIndex = event.previousPageIndex;
  
  let previousSize = pageSize * pageIndex;
  console.log("pageSize");
  console.log(pageSize);
  
  console.log("pageIndex");
  console.log(pageIndex);
  
 
this.getreportHistory(previousSize ,(pageIndex+1).toString()) ;
  
 
  
  
  }

  getreportHistory(currentSize ,offset) {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.URL = environment.apiUrl + "/reports/scheduler/log"+'?page='+ offset;
    this.http.get(this.URL, requestOptions).subscribe(
      (response : any) => {
        // this.tableDataSource = response;
        var historique: any = response;
        this.collection = [];

        this.lengthTotal = historique.length;

        var lgn: any = this.lengthTotal;
        this.lengthpage = parseInt("" + (lgn + 1) / this.pageSize);

        //console.log(this.lengthpage)

        if (this.lengthpage % 2 == 0) {
          for (var i = 0; i < this.lengthpage; i++) {
            this.collection.push(i + 1);
          }
        } else {
          for (var i = 0; i < this.lengthpage + 1; i++) {
            this.collection.push(i + 1);
          }
        }
        var list: any = response.data

        this.tableDataSource =response.data
      this.tableDataSource.push(...list);
  
        if (currentSize == 0 ){
          list.length =15 ;
        }else {
          list.length =currentSize ;
        }
  
        this.tableDataSource =response.data
        this.tableDataSource.push(...list);
        this.tableDataSource.length = response.total

        this.dataSource = new MatTableDataSource(this.tableDataSource);

        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
      (error) => {
        Swal.fire({
          text: "Un problème est survenu! " + error,
        });
      }
    );
  }

  generatePfdLog(e) {
    //console.log(e)

    this.critere = e.criteria;
    this.typerep = e.type;
    this.companie_id = e.company_id;
    this.id = e.id;

    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    var DateFilterStart = e.start_period;
    var DateFilterEnd = e.end_period;
    var concat = DateFilterStart + "~" + DateFilterEnd;
    //console.log(concat)

    this.URL =
      environment.apiUrl +
      "/companies/" +
      this.companie_id +
      "/reports/type/" +
      this.typerep +
      "/filter/" +
      concat +
      "/criteria/" +
      encodeURI(this.critere) +
      "?src=log&log_id=" +
      this.id;
    //console.log(this.URL)

    let options = {
      body: "La demande de génération de rapport a été envoyée au serveur. Vous serez notifié lorsque le rapport sera disponible.",
      icon: "https://www.searchpng.com/wp-content/uploads/2019/02/Reload-Blue-Icon-PNG.png",
    };

    this._pushNotifications.create("Rapport en cours", options).subscribe(
      (res) => {
        this.http.get(this.URL, requestOptions).subscribe((response) => {
          //console.log(response)

          var resp: any = response;

          var url: any = resp.url;
          this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
            resp.url
          );

          if (url != null) {
            res.notification.close();
            this.downoaldNotifications(resp.url).bind(this);
          }

          /*
  this.dialog.open(PdfDomComponent,{

    data: {
      animal: 'panda'
    },
    width: '70%',
    height: '67%',
    autoFocus: false,

    panelClass: 'my-custom-dialog-class'
  });
  */
          this.traslateService.urlPathlogQuote.next(this.urlSafe);
        });
      },

      (error) => {
        Swal.fire({
          text: "Un problème est survenu! " + error,
        });
      }
    );
  }
  downoaldNotifications(e): any {
    this._pushNotifications
      .create("Rapport disponible", {
        body: "Le rapport est terminé cliquer pour téléchargé",
        icon: "https://www.ontariohealthstudy.ca/wp-content/uploads/2019/02/pdf.png",
      })
      .subscribe((res) => {
        if (res.event.type === "click") {
          //console.log(res); //console.log(e);

          var link = document.createElement("a");
          link.href = e;
          link.download = "Rapport STG DRIVE" + new Date() + ".pdf";
          link.dispatchEvent(new MouseEvent("click"));
          res.notification.close();
        }
      });
  }
  supprimerRapport() {
    if (this.ItemSelected.length === 1) {
      Swal.fire({
        title: "Voulez vous supprimer l'alarme selectionnée ?",
        showCancelButton: true,
        confirmButtonColor: '#262756',
        cancelButtonColor: "#e05a61",
        confirmButtonText: "Oui",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire("", "l'alarme a été supprimer avec succès!");
        }
      });
    } else if (this.ItemSelected.length >= 1) {
      Swal.fire({
        title: "Voulez vous supprimer toutes les alarmes selectionnées?",
        showCancelButton: true,
        confirmButtonColor: '#262756',
        cancelButtonColor: "#e05a61",
        confirmButtonText: "Confirmer!",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire(
            "",
            "les alarmes selectionnées ont été supprimer avec succès!"
          );
        }
      });
    } else {
      Swal.fire({
        title: "Veuillez selectionner un enregistrement",
      });
    }
  }

  supprimerRapport_RightClick() {
    Swal.fire({
      title: "Voulez vous supprimer cette l'alarme ?",
      text: "Vous êtes sur le point de supprimer cette alarme!",
      showCancelButton: true,
      confirmButtonColor: '#262756',
      cancelButtonColor: "#e05a61",
      confirmButtonText: "Confirmer!",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("", "l'alarme a été supprimer avec succès!");
      }
    });
  }

  updateColor(progress) {
    if (progress > 80) {
      return "#78C000";
    } else if (progress <= 30) {
      return "#EB0000";
    } else {
      return "#FD7F20";
    }
  }
}

@Component({
  selector: "PdfDom",
  templateUrl: "./PdfDom.html",
  styleUrls: ["./report-history.component.scss"],
})
export class PdfDomComponent implements OnInit {
  url: any;

  constructor(public traslateService: TraslateService) {}
  ngOnInit(): void {
    this.traslateService.currentdatalogQuote.subscribe((data) => {
      this.url = data;
      //console.log(this.url)
    });
  }
}
